/**
 * Wire protocol for embedding the official Moonshort standalone-play Cocos
 * renderer. Constants + message shapes are dictated by the player's host
 * contract (see moonshort-standalone-play docs) — do not rename.
 *
 * The standalone player is the product renderer; a host embeds it in an iframe
 * and feeds it a *compiled* episode payload. Previews built on this host are
 * therefore identical to the shipped product by construction.
 */
/** CustomEvent name the player dispatches on its own window for host feedback. */
export const PLAY_EVENT_NAME = "moonshort-play:event";
/** `postMessage` envelope `type` the player accepts for data injection (host → iframe). */
export const PLAY_DATA_MESSAGE = "moonshort-play:data";
/** Global the player exposes on its own window once booted. */
export const PLAY_API_GLOBAL = "__MOONSHORT_PLAY_API__";
export function buildPlayDataMessage(data) {
    return { type: PLAY_DATA_MESSAGE, data };
}
export function isPlayDataMessage(value) {
    return (typeof value === "object" &&
        value !== null &&
        value.type === PLAY_DATA_MESSAGE);
}
